/**
 * 認証チェックの裏でマイアイテムを先に取りに行くための置き場。
 *
 * これまでは「認証が通る → 画面が出る → そこから一覧をfetch」と直列だったため、
 * バックエンド(Cloud Run)のコールドスタートぶんがまるごと待ち時間に乗っていた。
 * ログイン済みと分かった時点で取得を走らせておき、画面側はその Promise を待つだけにする。
 *
 * 取得そのものはユーザー本人のアイテムのGETで、副作用は無い。
 */

import type { FactCheckItem } from '../types';
import { getPersonalItems } from './factCheckItemService';

/** 先読み結果を使ってよい猶予。これを過ぎたら素直に取り直す */
const TTL_MS = 60_000;

let pending: Promise<FactCheckItem[]> | null = null;
let startedAt = 0;
let ownerUid: string | null = null;

/** ログイン済みと分かった時点で呼ぶ。二重に走らせない */
export function prefetchPersonalItems(uid: string): void {
  if (pending && ownerUid === uid && Date.now() - startedAt < TTL_MS) return;
  ownerUid = uid;
  startedAt = Date.now();
  // 失敗しても握りつぶす（画面側が改めて取りに行くため）
  pending = getPersonalItems().catch(() => {
    pending = null;
    return [];
  });
}

/**
 * 先読み済みがあれば受け取る（1回きり）。
 * 無い・古い・別ユーザーのものなら null を返すので、呼び出し側は通常取得に回す。
 */
export function takePrefetchedPersonalItems(uid: string): Promise<FactCheckItem[]> | null {
  if (!pending || ownerUid !== uid || Date.now() - startedAt > TTL_MS) return null;
  const p = pending;
  pending = null;
  return p;
}

/** ログアウト時に捨てる（別アカウントに持ち越さない） */
export function clearPrefetch(): void {
  pending = null;
  ownerUid = null;
  startedAt = 0;
}
